"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialNav = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@emotion/react");

var _SocialIcon = require("./SocialIcon");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: row;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0 1rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var iconMargins = (0, _react2.css)(_templateObject());

var SocialNav = function SocialNav(_ref) {
  var color = _ref.color,
      props = (0, _objectWithoutProperties2.default)(_ref, ["color"]);
  return (0, _react2.jsx)("nav", Object.assign({
    css: (0, _react2.css)(_templateObject2())
  }, props), (0, _react2.jsx)(_SocialIcon.SocialIcon, {
    color: color,
    site: "twitter",
    css: iconMargins
  }), (0, _react2.jsx)(_SocialIcon.SocialIcon, {
    color: color,
    site: "instagram",
    css: iconMargins
  }), (0, _react2.jsx)(_SocialIcon.SocialIcon, {
    color: color,
    site: "facebook",
    css: iconMargins
  }));
};

exports.SocialNav = SocialNav;